import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const navLinks = [
  { path: "/", label: "Home" },
  { path: "/about", label: "About" },
  { path: "/services", label: "Services" },
  { path: "/contact", label: "Contact" },
];

const socials = [
  { label: "Instagram", href: "https://www.instagram.com/Nyxlabs_/", icon: "◈" },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/paras-ahuja-46b647350?utm_source=share_via&utm_content=profile&utm_medium=member_android", icon: "◉" },
  { label: "GitHub", href: "https://github.com/Paras-web-dev", icon: "⬡" },
];

export default function Footer() {
  return (
    <motion.footer
      className="nyx-footer"
      initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}
      viewport={{ once: true }} transition={{ duration: 0.8 }}
      style={{
        borderTop: "1px solid rgba(124,58,237,0.12)",
        padding: "64px 60px 32px",
        background: "rgba(5,5,8,0.8)",
        backdropFilter: "blur(24px)",
        position: "relative", overflow: "hidden",
      }}>

      {/* Glow accent */}
      <div style={{
        position: "absolute", top: -80, left: "50%", transform: "translateX(-50%)",
        width: 600, height: 200, borderRadius: "50%",
        background: "radial-gradient(ellipse, rgba(124,58,237,0.08), transparent 70%)",
        pointerEvents: "none",
      }} />

      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div className="footer-main-grid" style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr", gap: 48, marginBottom: 56 }}>

          {/* Brand */}
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
              <motion.div whileHover={{ rotate: 15, boxShadow: "0 0 20px rgba(124,58,237,0.6)" }}
                style={{
                  width: 36, height: 36, borderRadius: 10,
                  background: "linear-gradient(135deg, #7c3aed, #e879f9)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 16, fontWeight: 800, fontFamily: "'Syne',sans-serif", color: "#fff",
                  transition: "box-shadow 0.3s ease",
                }}>N</motion.div>
              <span style={{
                fontFamily: "'Syne',sans-serif", fontWeight: 800, fontSize: 22,
                background: "linear-gradient(90deg, #a855f7, #e879f9)",
                WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text",
              }}>NyxLabs</span>
            </div>
            <p style={{
              fontFamily: "'DM Sans',sans-serif", fontSize: 14, lineHeight: 1.75,
              color: "rgba(241,240,245,0.38)", maxWidth: 300, marginBottom: 24,
            }}>
              Crafting immersive digital systems with precision, aesthetic depth,
              and performance-driven architecture. Built in the dark.
            </p>
            <motion.a href="mailto:nyxlabsweb@gmail.com"
              whileHover={{ color: "#c084fc", x: 4 }}
              style={{
                fontFamily: "'DM Sans',sans-serif", fontSize: 13, color: "#a855f7",
                textDecoration: "none", display: "flex", alignItems: "center", gap: 6,
                transition: "color 0.2s ease",
              }}>
              ✉ nyxlabsweb@gmail.com
            </motion.a>
          </div>

          {/* Nav */}
          <div>
            <h4 style={{
              fontFamily: "'Syne',sans-serif", fontWeight: 700, fontSize: 12,
              color: "#f1f0f5", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20,
            }}>Explore</h4>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {navLinks.map(link => (
                <motion.div key={link.path} whileHover={{ x: 4 }}>
                  <Link to={link.path} style={{
                    fontFamily: "'DM Sans',sans-serif", fontSize: 14,
                    color: "rgba(241,240,245,0.4)", textDecoration: "none",
                    transition: "color 0.2s ease", display: "block",
                  }}
                    onMouseEnter={e => e.target.style.color = "#c084fc"}
                    onMouseLeave={e => e.target.style.color = "rgba(241,240,245,0.4)"}
                  >{link.label}</Link>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 style={{
              fontFamily: "'Syne',sans-serif", fontWeight: 700, fontSize: 12,
              color: "#f1f0f5", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20,
            }}>Connect</h4>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {socials.map(s => (
                <motion.a key={s.label} href={s.href} target="_blank" rel="noreferrer"
                  whileHover={{ x: 4, color: "#c084fc" }}
                  style={{
                    fontFamily: "'DM Sans',sans-serif", fontSize: 14,
                    color: "rgba(241,240,245,0.4)", textDecoration: "none",
                    display: "flex", alignItems: "center", gap: 8,
                    transition: "color 0.2s ease",
                  }}>
                  <span style={{ color: "#7c3aed" }}>{s.icon}</span> {s.label}
                </motion.a>
              ))}
            </div>
          </div>
        </div>

        {/* Animated divider */}
        <motion.div
          animate={{ backgroundPosition: ["0% 0%", "100% 0%"] }}
          transition={{ duration: 4, repeat: Infinity, ease: "linear" }}
          style={{
            height: 1, marginBottom: 28,
            background: "linear-gradient(90deg, transparent, rgba(124,58,237,0.4), rgba(232,121,249,0.4), transparent)",
            backgroundSize: "200% 100%",
          }} />

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
          <p style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, color: "rgba(241,240,245,0.2)" }}>
            © 2026 NyxLabs. All Rights Reserved.
          </p>
          <p style={{
            fontFamily: "'DM Sans',sans-serif", fontSize: 11, letterSpacing: "0.05em",
            color: "rgba(241,240,245,0.15)", textTransform: "uppercase"
          }}>
            Crafted in Darkness. Engineered with Precision.
          </p>
        </div>
      </div>

      <style>{`
        @media (max-width: 992px) {
          .footer-main-grid { grid-template-columns: 1fr 1fr !important; gap: 28px !important; }
          .nyx-footer { padding: 52px 30px 28px !important; }
        }
        @media (max-width: 768px) {
          .footer-main-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
          .nyx-footer { padding: 40px 20px 24px !important; }
        }
      `}</style>
    </motion.footer>
  );
}
